export const FETCH_PRODUCT = 'ACCOUNTS_MARKETPLACE/FETCH_PRODUCT'
export const SET_DATA = 'ACCOUNTS_MARKETPLACE/PRODUCT_SET_DATA'
export const SET_LOADING = 'ACCOUNTS_MARKETPLACE/PRODUCT_SET_LOADING'
